var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificateValidation"},[_c('van-nav-bar',{attrs:{"title":"证书验证"}}),_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.businessName)+"证书查询结果")]),_c('img',{staticClass:"img",attrs:{"src":_vm.info.url,"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }